import { getHtmlEmailLink, getHtmlTelLink } from '../../../utils/link'

export const USER_PROFILE_LOG_EVENTS_PAGE_SIZE = 20

export const USER_PROFILE_LOG_ACTION = {
  ADD_TO_FLAT: 'add_to_flat',
  ARCHIVE: 'archive',
  BLOCK: 'block',
  CREATE: 'create',
  INVITE: 'invite',
  MOVE_OUT_FROM_FLAT: 'move_out_from_flat',
  RESTORE: 'restore',
  SELF_REGISTRATION: 'self_registration',
  UNBLOCK: 'unblock',
  UPDATE_ADDITIONAL_EMAIL: 'update_additional_email',
  UPDATE_ADDITIONAL_PHONE: 'update_additional_phone',
  UPDATE_AUTH_EMAIL: 'update_auth_email',
  UPDATE_AUTH_PHONE: 'update_auth_phone',
  UPDATE_EXTERNAL_ID: 'update_external_id',
  VALIDATE: 'validate',
}

export const USER_PROFILE_LOG_ACTION_TRANSLATION_KEY = {
  [USER_PROFILE_LOG_ACTION.ADD_TO_FLAT]: 'UserLog.AddedToFlatKey',
  [USER_PROFILE_LOG_ACTION.ARCHIVE]: 'UserLog.ArchivedKey',
  [USER_PROFILE_LOG_ACTION.BLOCK]: 'UserLog.StatusChangedKey',
  [USER_PROFILE_LOG_ACTION.CREATE]: 'UserLog.CreatedKey',
  [USER_PROFILE_LOG_ACTION.INVITE]: 'UserLog.InvitedKey',
  [USER_PROFILE_LOG_ACTION.MOVE_OUT_FROM_FLAT]: 'UserLog.MovedOutFromFlatKey',
  [USER_PROFILE_LOG_ACTION.RESTORE]: 'UserLog.RestoredKey',
  [USER_PROFILE_LOG_ACTION.SELF_REGISTRATION]: 'UserLog.SelfRegisteredKey',
  [USER_PROFILE_LOG_ACTION.UNBLOCK]: 'UserLog.StatusChangedKey',
  [USER_PROFILE_LOG_ACTION.UPDATE_ADDITIONAL_EMAIL]:
    'UserLog.AdditionalEmailChangedKey',
  [USER_PROFILE_LOG_ACTION.UPDATE_ADDITIONAL_PHONE]:
    'UserLog.AdditionalPhoneChangedKey',
  [USER_PROFILE_LOG_ACTION.UPDATE_AUTH_EMAIL]: 'UserLog.AuthEmailChangedKey',
  [USER_PROFILE_LOG_ACTION.UPDATE_AUTH_PHONE]: 'UserLog.AuthPhoneChangedKey',
  [USER_PROFILE_LOG_ACTION.UPDATE_EXTERNAL_ID]: 'UserLog.ExternalIdChangedKey',
  [USER_PROFILE_LOG_ACTION.VALIDATE]: 'UserLog.ValidatedKey',
}

export const USER_PROFILE_LOG_STATUS_ACTIONS = [
  USER_PROFILE_LOG_ACTION.BLOCK,
  USER_PROFILE_LOG_ACTION.UNBLOCK,
]

export const USER_PROFILE_LOG_ENTITY_LINK_ACTIONS = [
  USER_PROFILE_LOG_ACTION.ADD_TO_FLAT,
  USER_PROFILE_LOG_ACTION.MOVE_OUT_FROM_FLAT,
]

export const USER_PROFILE_LOG_CONTACT_ACTION_LINK_GETTER = {
  [USER_PROFILE_LOG_ACTION.UPDATE_ADDITIONAL_EMAIL]: getHtmlEmailLink,
  [USER_PROFILE_LOG_ACTION.UPDATE_ADDITIONAL_PHONE]: getHtmlTelLink,
  [USER_PROFILE_LOG_ACTION.UPDATE_AUTH_EMAIL]: getHtmlEmailLink,
  [USER_PROFILE_LOG_ACTION.UPDATE_AUTH_PHONE]: getHtmlTelLink,
}

export const USER_PROFILE_LOG_TRANSLATION_TAG_REGEXP =
  /<\/?(?:flatLink|buildingLink|prevLink|currLink)>/g

export const QA_NAME_USER_PROFILE_TAB_UPDATES = 'userProfileTabUpdates'
